module.exports = __webpack_public_path__ + "static/fonts/wizard.d52f48e4.ttf";